import { graphql, Link } from "gatsby"
import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Signup from "../components/signup"
import { MDXRenderer } from "gatsby-plugin-mdx"
import "./blog-post.css"

const BlogPostTemplate = ({ data, pageContext }) => {
  const post = data.mdx
  const { previous, next } = pageContext

  return (
    <Layout>
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        type="article"
        datePublished={post.frontmatter.date}
        slug={pageContext.slug}
      />
      <div className="container">
        <div className="post-header fade-hero">
          <div className="page-eyebrow">{post.frontmatter.date}</div>
          <h1 className="post-title">{post.frontmatter.title}</h1>
        </div>

        <div className="post-body fade-content">
          <MDXRenderer>{post.body}</MDXRenderer>
        </div>

        <div className="post-footer fade-footer">
          <Signup />
          <nav className="post-nav">
            <div className="post-nav-item">
              {previous && (
                <Link to={previous.fields.slug} rel="prev">
                  ← {previous.frontmatter.title}
                </Link>
              )}
            </div>
            <div className="post-nav-item post-nav-next">
              {next && (
                <Link to={next.fields.slug} rel="next">
                  {next.frontmatter.title} →
                </Link>
              )}
            </div>
          </nav>
        </div>
      </div>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      body
      frontmatter {
        title
        date(formatString: "MMM DD, YYYY")
        description
      }
    }
  }
`
